import { makeObservable, observable, action, runInAction } from "mobx";

import { getCategories, getProjects, getCategoriesNewCheck } from "../api";
import { GlobalErrorType, IApiHeader } from "./appStoreTypes";
import {
  ICategoryState,
  ICategory,
  IFeedState,
  initialFeedState,
  ICategoryNewProject,
  IProject,
} from "./feedStoreTypes";

export default class FeedStore {
  constructor() {
    makeObservable(this, {
      categoryState: observable,
      onGetCategoryList: action,
      onSelectedCategory: action,

      feedState: observable,
      onUpdateFeedList: action,

      feedErrorState: observable,
      onUpdateFeedError: action,
      onGetCategoryNewProject: action,

      onUpdateLikeCounts: action,
      onUpdateUnlikeCounts: action,
      onUpdateDownloadCounts: action,
      onUpdateListCount: action,
    });
  }

  categoryState: ICategoryState = {
    list: [],
    isLoadingList: true,
  };
  onGetCategoryList = async (apiHeader: IApiHeader) => {
    const categoryState = this.categoryState;
    categoryState.isLoadingList = true;

    try {
      const { data, error } = await getCategories(apiHeader);

      if (error) {
        return this.onUpdateFeedError(GlobalErrorType.NET_WORK);
      }

      runInAction(() => {
        if (data)
          categoryState.list = data.map((item: ICategory) => {
            return {
              ...item,
              badge: true,
            };
          });
        this.onGetCategoryNewProject(apiHeader);
      });
    } catch {
      this.onUpdateFeedError(GlobalErrorType.UNKNOWN);
    }
  };
  onGetCategoryNewProject = async (apiHeader: IApiHeader) => {
    const categoryState = this.categoryState;

    try {
      const { data, error } = await getCategoriesNewCheck(apiHeader);

      if (error) {
        return this.onUpdateFeedError(GlobalErrorType.NET_WORK);
      }

      runInAction(() => {
        if (data) {
          categoryState.list = categoryState.list.map((listItem) => {
            const fIndex = data.findIndex(
              (item: ICategoryNewProject) =>
                item.categoryId === listItem.categoryId
            );
            if (fIndex === -1) return listItem;
            return { ...listItem, badge: false };
          });
        }
        categoryState.isLoadingList = false;
      });
    } catch {
      this.onUpdateFeedError(GlobalErrorType.UNKNOWN);
    }
  };
  onSelectedCategory = (apiHeader: IApiHeader, id?: string) => {
    const categoryState = this.categoryState;
    categoryState.list = categoryState.list.map((item) => {
      if (item.categoryId === id)
        return {
          ...item,
          badge: true,
        };
      return item;
    });

    categoryState.selectedId = id;

    // feedState 초기화 및 1page 호출
    this.feedState = initialFeedState;
    this.onUpdateFeedList(apiHeader, 1);
  };

  feedState: IFeedState = initialFeedState;
  onUpdateFeedList = async (apiHeader: IApiHeader, targetPage?: number) => {
    const feedState = this.feedState;
    const { selectedId: categoryId } = this.categoryState;

    feedState.isLoadingList = true;
    const page = targetPage ? targetPage : feedState.page;

    try {
      const { data, error } = await getProjects({
        ...apiHeader,
        page,
        categoryId,
        display: feedState.display,
        type: "projects",
      });

      if (error) {
        return this.onUpdateFeedError(GlobalErrorType.NET_WORK);
      }

      runInAction(() => {
        if (!data) throw console.error("onUpdateFeedList is fail!");
        if (data.length === 0) return console.log("onUpdateFeedList is empty");

        if (page === 1) {
          feedState.list = data;
        } else {
          feedState.list = feedState.list.concat(data);
        }
        feedState.page = page + 1;
      });
    } catch {
      this.onUpdateFeedError(GlobalErrorType.UNKNOWN);
    } finally {
      runInAction(() => {
        feedState.isLoadingList = false;
      });
    }
  };

  feedErrorState = GlobalErrorType.NONE;
  onUpdateFeedError = (state: GlobalErrorType) => {
    this.feedErrorState = state;
    this.feedState.isLoadingList = false;
    this.categoryState.isLoadingList = false;
  };

  onUpdateLikeCounts = (id: string) => {
    this.feedState.list = this.onUpdateListCount(
      "likeCounts",
      id,
      true,
      this.feedState.list
    );
  };
  onUpdateUnlikeCounts = (id: string) => {
    this.feedState.list = this.onUpdateListCount(
      "likeCounts",
      id,
      false,
      this.feedState.list
    );
  };
  onUpdateDownloadCounts = (id: string) => {
    this.feedState.list = this.onUpdateListCount(
      "downloadCounts",
      id,
      true,
      this.feedState.list
    );
  };
  onUpdateListCount = (
    key: "likeCounts" | "downloadCounts",
    id: string,
    isIncrease: boolean,
    list: IProject[]
  ) => {
    return list.map((project) => {
      if (project.projectId === id) {
        const num = isIncrease ? +1 : -1;
        return {
          ...project,
          [key]: project[key] + num,
        };
      }
      return project;
    });
  };
}
